var map = {
    "ar-sa": "ar-sa",
    "de-de": "de-de",
    "en-us": "en-us",
    "es-es": "es-es",
    "in-id": "in-id",
    "fr-fr": "fr-fr",
    "it-it": "it-it",
    "iw-il": "iw-il",
    "nl-nl": "nl-nl",
    "ko-kr": "ko-kr",
    "ja-jp": "ja-jp",
    "pt-pt": "pt-pt",
    "ru-ru": "ru-ru",
    "th-th": "th-th",
    "tr-tr": "tr-tr",
    "vi-vi": "vi-vi",
    "zh-cn": "zh-cn",
    "zh-tw": "zh-tw",
    "hindi": "hindi"
};
var i18n = {
    "ar-sa": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "إلي",
                "feedback.msgsend.screen.memberInquiry.button.send": "إرسال",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "شكرا لك! قد تم إرسال رسالتك بنجاح إلي المور",
                "feedback.msgsend.control.stickLogin.email.must": "ادخل بريدك.",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "من فضلك قم بتوصيتي بمزيد من الموردين المنتقين إذا لم يقم هذا المورد بالاتصال بي عبر \"مركز التراسل\" خلال 24 ساعة.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "يجب أن تكون رسالتك ما بين 20-8000 حرفا",
                "feedback.msgsend.control.privacy": "أوافق على مشاركة </span>بطاقة العمل <span class=\"stress\"> الخاصة بي مع الموردين.",
                "feedback.msgsend.screen.inquiry.from": "من",
                "feedback.msgsend.screen.inquiry.message": "رسالة",
                "feedback.msgsend.whatyouneed": "دع الموردين المنشودين المؤكدين يعثرون عليك.       \nفقط أخبرنا بم تحتاج!",
                "Aselfintroduction": "- مقدمة ذاتية",
                "feedback.msgsend.getquatation": "احصل على اقتباسات",
                "feedback.msgsend.control.msgQuantity.limit.number": "يرجي إدخال رقم.",
                "Specialrequestsifany": "- طلبات خاصة, ان وجدت",
                "feedback.msgsend.control.msgQuantity.quantity": "الكمية",
                "feedback.msgsend.screen.inquiry.message.info": "أدخل تفاصيل الاستفسار مثل اسم المنتج واللون والحجم والحد الأدني للطلب وسعر الفوب",
                "feedback.msgsend.control.tipContent.view.sample": "مشاهدة عينة",
                "Forbetterresponsespleaseinclude": "للحصول علي ردود اكثر فعالية, تأكد من إرفاق:",
                "feedback.msgsend.control.msgContent.msg.must": "Please enter the content."
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "de-de": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "An",
                "feedback.msgsend.screen.memberInquiry.button.send": "Schicken",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "Vielen Dank! Ihre Nachricht ist erfolgreich an den Lieferant geschickt worden.",
                "feedback.msgsend.control.stickLogin.email.must": "Geben Sie E-Mail.",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Bitte empfehlen Sie mir weitere ausgewählte Anbieter, sollte dieser Anbieter mich nicht in den nächsten 24 Stunden über das \"Nachrichten-Center\" kontaktieren.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Ihre Nachricht muss zwischen 20-8000 Buchstaben sein",
                "feedback.msgsend.control.privacy": "Ich bin einverstanden, meine  <span class=\"stress\">Geschäftskarte</span> mit den Lieferanten zu teilen.",
                "feedback.msgsend.screen.inquiry.from": "Von",
                "feedback.msgsend.screen.inquiry.message": "Nachricht",
                "feedback.msgsend.whatyouneed": "Lassen Sie sich von passenden überprüften Lieferanten finden.\nSagen Sie uns einfach, was Sie brauchen!",
                "Aselfintroduction": "- Stellen Sie sich selbst vor",
                "feedback.msgsend.getquatation": "Angebote Ansehen",
                "feedback.msgsend.control.msgQuantity.limit.number": "Bitte geben Sie eine Nummer ein.",
                "Specialrequestsifany": "- Besondere Anforderungen, falls zutreffend",
                "feedback.msgsend.control.msgQuantity.quantity": "Menge",
                "feedback.msgsend.screen.inquiry.message.info": "Geben Sie Ihre Anfrage-Information ein, wie Produktsname, Farbe, Größe, Mindestbestellmengen, FOB-Preis u.s.w.",
                "feedback.msgsend.control.tipContent.view.sample": "Beispiel anschauen",
                "Forbetterresponsespleaseinclude": "Um bessere Antworten zu bekommen, machen Sie bitte auch folgende Angaben:",
                "feedback.msgsend.control.msgContent.msg.must": "Inhalt angeben"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "en-us": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "To",
                "feedback.msgsend.screen.memberInquiry.button.send": "Send",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "Thank you! Your message has been successfully sent to the supplier.",
                "feedback.msgsend.control.stickLogin.email.must": "Enter email or Member ID.",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Recommend matching suppliers if this supplier doesn’t contact me on Message Center within 24 hours.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Your message must be between 20-8000 characters",
                "feedback.msgsend.control.privacy": "I agree to share my <span class=\"stress\">Business Card</span> to the supplier.",
                "feedback.msgsend.screen.inquiry.from": "From",
                "feedback.msgsend.screen.inquiry.message": "Message",
                "feedback.msgsend.whatyouneed": "Let  verified  suppliers find you.\nJust tell us what you need！",
                "Aselfintroduction": "- A self introduction",
                "feedback.msgsend.getquatation": "Get Quotation Now!",
                "feedback.msgsend.control.msgQuantity.limit.number": "Please enter a number.",
                "Specialrequestsifany": "- Special requests, if any",
                "feedback.msgsend.control.msgQuantity.quantity": "Quantity",
                "feedback.msgsend.screen.inquiry.message.info": "Enter your inquiry details such as product name, color, size, MOQ, FOB, etc.",
                "feedback.msgsend.control.tipContent.view.sample": "View Sample",
                "Forbetterresponsespleaseinclude": "For better quotations, include:",
                "feedback.msgsend.control.msgContent.msg.must": "Please enter the content."
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "es-es": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "Para",
                "feedback.msgsend.screen.memberInquiry.button.send": "Enviar",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "Gracias! Su mensaje ha sido enviado al proveedor con éxito.",
                "feedback.msgsend.control.stickLogin.email.must": "Introduzca su email.",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Por favor recomiéndame más proveedores seleccionados si este proveedor no me responde a través del Centro de Mensajes en un plazo de 24 horas.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Su mensaje debe tener entre 20 y 8000 caracteres.",
                "feedback.msgsend.control.privacy": "Facilitar mi  <span class=\"stress\">Tarjeta de Presentación</span>",
                "feedback.msgsend.screen.inquiry.from": "De",
                "feedback.msgsend.screen.inquiry.message": "Mensaje",
                "feedback.msgsend.whatyouneed": "Deja que los proveedores verificados correspondientes te encuentren.\n¡Simplemente dinos qué necesitas!",
                "Aselfintroduction": "Presentación personal",
                "feedback.msgsend.getquatation": "Obtener ofertas",
                "feedback.msgsend.control.msgQuantity.limit.number": "Introduzca una cifra.",
                "Specialrequestsifany": "Requisitos especiales, si los hubiera",
                "feedback.msgsend.control.msgQuantity.quantity": "Cantidad",
                "feedback.msgsend.screen.inquiry.message.info": "Introduzca la información de su consulta. Por ejemplo: el nombre del producto, el tamaño, el color, la cantidad mínima de pedido, el precio FOB, etc.",
                "feedback.msgsend.control.tipContent.view.sample": "Ver un ejemplo",
                "Forbetterresponsespleaseinclude": "Para mejores respuestas, por favor incluye:",
                "feedback.msgsend.control.msgContent.msg.must": "Por favor ingrese el contenido"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "in-id": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "Ke",
                "feedback.msgsend.screen.memberInquiry.button.send": "Kirim",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "Terima kasih! Pesan anda telah berhasil dikirimkan ke pemasok.",
                "feedback.msgsend.control.stickLogin.email.must": "Masukkan email atau ID Anggota.",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Rekomendasikan supplier yang sesuai jika supplier ini tidak menghubungi saya di Pusat Pesan dalam 24 jam.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Pesan Anda harus antara 20-8000 karakter",
                "feedback.msgsend.control.privacy": "Saya setuju untuk membagi  <span class=\"stress\">Kartu Nama</span> saya dengan supplier.",
                "feedback.msgsend.screen.inquiry.from": "Dari",
                "feedback.msgsend.screen.inquiry.message": "pesan",
                "feedback.msgsend.whatyouneed": "Biarkan pemasok terverifikasi menemukanmu. Beritahu kami apa yang Anda perlukan!",
                "Aselfintroduction": "Perkenalan diri",
                "feedback.msgsend.getquatation": "Dapatkan Penawaran Sekarang!",
                "feedback.msgsend.control.msgQuantity.limit.number": "Mohon masukkan angka.",
                "Specialrequestsifany": "Permintaan khusus, jika ada",
                "feedback.msgsend.control.msgQuantity.quantity": "Jumlah",
                "feedback.msgsend.screen.inquiry.message.info": "Masukkan rincian pertanyaan Anda seperti nama produk, warna, ukuran, MOQ, FOB, dsb.",
                "feedback.msgsend.control.tipContent.view.sample": "Lihat Sampel",
                "Forbetterresponsespleaseinclude": "Untuk kuotasi yang lebih baik, sertakan:",
                "feedback.msgsend.control.msgContent.msg.must": "Harap lengkapi kolom."
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "fr-fr": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "à",
                "feedback.msgsend.screen.memberInquiry.button.send": "Envoyer",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "Merci! Votre message a bien été envoyé au fournisseur.",
                "feedback.msgsend.control.stickLogin.email.must": "Entrez e-mail.",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Me recommander davantage de fournisseurs sélectionnés si ce fournisseur ne me contacte pas sur le Centre de messages dans les 24 heures.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Votre message doit être compris entre 20-8000 caractères",
                "feedback.msgsend.control.privacy": "Je suis d'accord pour partager ma <span class=\"stress\">Carte de Visite</span> avec le(s) fournisseur(s).",
                "feedback.msgsend.screen.inquiry.from": "De",
                "feedback.msgsend.screen.inquiry.message": "Message",
                "feedback.msgsend.whatyouneed": "Laissez les fournisseurs vérifiés correspondants vous trouver. \nDites-nous seulement ce dont vous avez besoin!",
                "Aselfintroduction": "- Une présentation",
                "feedback.msgsend.getquatation": "Obtenir un devis maintenant",
                "feedback.msgsend.control.msgQuantity.limit.number": "Entrez le numéro.",
                "Specialrequestsifany": "- Toute requête spécifique si nécessaire",
                "feedback.msgsend.control.msgQuantity.quantity": "Quantité",
                "feedback.msgsend.screen.inquiry.message.info": "Informations d'appel d'offre a entrer,par exemple: nom de produit, couleur,dimensions de produit quantite minimale de commande, prix FOB etc",
                "feedback.msgsend.control.tipContent.view.sample": "Visionner un échantillon",
                "Forbetterresponsespleaseinclude": "Pour obtenir de meilleures réponses, veuillez inclure :",
                "feedback.msgsend.control.msgContent.msg.must": "Veuillez saisir le contenu"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "it-it": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "A",
                "feedback.msgsend.screen.memberInquiry.button.send": "Invii",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "Grazie! Il tuo messaggio e' inviato con successo al fornitore.",
                "feedback.msgsend.control.stickLogin.email.must": "Inserisci email.",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Per favore consigliatemi altri fornitori selezionati se questo fornitore non mi contatta nel \"centro messaggi\" entro 24 ore.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "I tuoi messaggi deve essere tra 20—8000 caratteri.",
                "feedback.msgsend.control.privacy": "Acconsento a condividere la mia <span class=\"stress\">Business Card</span>  con i(l) fornitori(e).",
                "feedback.msgsend.screen.inquiry.from": "Da",
                "feedback.msgsend.screen.inquiry.message": "Messaggio",
                "feedback.msgsend.whatyouneed": "Lascia che i fornitori che cerchi ti trovino. \r\nTi basta dirci di che cosa hai bisogno!",
                "Aselfintroduction": "- Una tua presentazione",
                "feedback.msgsend.getquatation": "Ottieni Preventivi",
                "feedback.msgsend.control.msgQuantity.limit.number": "Si prega di inserire un numero.",
                "Specialrequestsifany": "- Eventuali richieste particolari",
                "feedback.msgsend.control.msgQuantity.quantity": "Quantità",
                "feedback.msgsend.screen.inquiry.message.info": "Inserisci i dettagli della richiesta (nome del prodotto, colore, dimensione, quantità minima di ordine, prezzo FOB, ecc.)",
                "feedback.msgsend.control.tipContent.view.sample": "Visualizza esempio",
                "Forbetterresponsespleaseinclude": "Per ottenere risposte migliori, includi:",
                "feedback.msgsend.control.msgContent.msg.must": "Devi compilare il campo."
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "iw-il": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "אל",
                "feedback.msgsend.screen.memberInquiry.button.send": "שלח",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "תודה לכם! ההודעה שלכם נשלחה בהצלחה לספק.",
                "feedback.msgsend.control.stickLogin.email.must": "הזינו דוא\"ל או מספר זיהוי חבר",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "המלץ ספקים מתאימים אם ספק זה לא יוצר עימי קשר במרכז הודעות תוך 24 שעות.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "ההודעה שלכם צריכה להכיל 8,000-20 תווים",
                "feedback.msgsend.control.privacy": "אני מסכימ/ה לשתף את</span> כרטיס הביקור<span class=\"stress\"> שלי עם הספק(ים).",
                "feedback.msgsend.screen.inquiry.from": "מ",
                "feedback.msgsend.screen.inquiry.message": "הודעה",
                "feedback.msgsend.whatyouneed": "תנו לספקים מורשים למצוא אתכם. רק ספרו לנו מה אתם צריכים!",
                "Aselfintroduction": "- הקדמה עצמי",
                "feedback.msgsend.control.msgQuantity.limit.number": "בבקשה הכניסו מספר.",
                "Specialrequestsifany": "- בקשות מיוחדות, אם קיימות",
                "feedback.msgsend.control.msgQuantity.quantity": "כמות",
                "feedback.msgsend.screen.inquiry.message.info": "הזינו את פרטי השאילתא שלנו, כמו שם המוצר, צבע, גודל, MOQ, FOB ועוד.",
                "feedback.msgsend.control.tipContent.view.sample": "ראה דוגמא",
                "Forbetterresponsespleaseinclude": "להצעות מחיר טובות יותר, הוסיפו:",
                "feedback.msgsend.control.msgContent.msg.must": "בבקשה הזינו את ההודעה שלכם"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "nl-nl": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "Aan",
                "feedback.msgsend.screen.memberInquiry.button.send": "Verstuur",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "Dank u wel! Uw bericht is succesvol verzonden naar de leverancier.",
                "feedback.msgsend.control.stickLogin.email.must": "Voer e-mail of lidmaatschap-ID in.",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Beveel passende leveranciers aan als deze leverancier geen contact met mij opneemt op berichtencentrum binnen 24 uur.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Uw bericht moet tussen 20-8000 tekens zijn",
                "feedback.msgsend.control.privacy": "Ik ga akkoord om mijn <span class=\"stress\">visitekaartje</span> met de leverancier(s) te delen.",
                "feedback.msgsend.screen.inquiry.from": "Van",
                "feedback.msgsend.screen.inquiry.message": "bericht",
                "feedback.msgsend.whatyouneed": "\"Laat gecertificeerde leveranciers u vinden.",
                "Aselfintroduction": "- Een zelfintroductie",
                "feedback.msgsend.getquatation": "Krijg offertes",
                "feedback.msgsend.control.msgQuantity.limit.number": "Voer een getal in.",
                "Specialrequestsifany": "- Speciale verzoeken, indien van toepassing",
                "feedback.msgsend.control.msgQuantity.quantity": "Hoeveelheid",
                "feedback.msgsend.screen.inquiry.message.info": "Vul uw aanvraag details zoals naam van het product, kleur, grootte, MOQ, FOB, etc.",
                "feedback.msgsend.control.tipContent.view.sample": "Bekijk voorbeeld",
                "Forbetterresponsespleaseinclude": "Voor een betere offertes, zijn onder meer:",
                "feedback.msgsend.control.msgContent.msg.must": "Voer het aantal in"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "ko-kr": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "수신자",
                "feedback.msgsend.screen.memberInquiry.button.send": "송신",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "감사합니다! 메시지가 성공적으로 공급 업체로 전송되었습니다.",
                "feedback.msgsend.control.stickLogin.email.must": "이메일을 입력합니다.",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "이 공급자가 24시간 이내에 '메시지 센터'로 연락하지 않을 경우, 보다 엄선된 공급자를 추천해 주세요.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "메시지 내용은 20-8000자 여야 합니다",
                "feedback.msgsend.control.privacy": "공급업체(들)에게 내 <span class=\"stress\">명함을</span> 공유하는데 동의합니다.",
                "feedback.msgsend.screen.inquiry.from": "송신자",
                "feedback.msgsend.screen.inquiry.message": "메시지",
                "feedback.msgsend.whatyouneed": "조건에 맞는 인증 공급자를 찾아 드리겠습니다.\n저희에게 말씀만 해주세요!",
                "Aselfintroduction": "- 자기 소개",
                "feedback.msgsend.getquatation": "견적 받기",
                "feedback.msgsend.control.msgQuantity.limit.number": "숫자를 입력해 주십시오.",
                "Specialrequestsifany": "- 가능한 경우, 특별한 요청 사항",
                "feedback.msgsend.control.msgQuantity.quantity": "수량",
                "feedback.msgsend.screen.inquiry.message.info": "당신의 견적조회 정보를 입력해 주세요. 예하면 제품명칭, 칼라, 규격, 최소 주문량, FOB가격 등",
                "feedback.msgsend.control.tipContent.view.sample": "샘플 보기",
                "Forbetterresponsespleaseinclude": "더 좋은 응답을 위해 다음과 같은 사항을 포함시키세요:",
                "feedback.msgsend.control.msgContent.msg.must": "내용을 입력하십시오."
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "ja-jp": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "受取人",
                "feedback.msgsend.screen.memberInquiry.button.send": "送信",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "ありがとうございます！お問い合わせメッセージはサプライヤーに配信しました！",
                "feedback.msgsend.control.stickLogin.email.must": "メールアドレスを入力してください．",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "このサプライヤーが24時間内に｢メッセージセンター｣へ連絡していない場合は、他の厳選したサプライヤーをマッピングしてお勧めます。",
                "feedback.msgsend.control.msgContent.msg.char.limit": "メッセージ内容は、20～8000文字にしてください",
                "feedback.msgsend.control.privacy": "サプライヤーに<span class=\"stress\">名刺</span>をシェアすることに承諾します。",
                "feedback.msgsend.screen.inquiry.from": "差出人",
                "feedback.msgsend.screen.inquiry.message": "メッセージ",
                "feedback.msgsend.whatyouneed": "認定サプライヤーマッチングに見つけてもらいましょう。\n必要なものを伝えるだけです！",
                "Aselfintroduction": "- 自己紹介",
                "feedback.msgsend.getquatation": "見積取得",
                "feedback.msgsend.control.msgQuantity.limit.number": "数字を入力してください。",
                "Specialrequestsifany": "- 特別な要求事項(何かある場合)",
                "feedback.msgsend.control.msgQuantity.quantity": "数量",
                "feedback.msgsend.screen.inquiry.message.info": "お問合せ情報をご入力ください。たとえば、製品名、色、寸法、最低注文量、FOB価格など",
                "feedback.msgsend.control.tipContent.view.sample": "サンプルを見る",
                "Forbetterresponsespleaseinclude": "返信しやすくするために、以下の情報を含めてください。",
                "feedback.msgsend.control.msgContent.msg.must": "内容を入力してください"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "pt-pt": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "Para",
                "feedback.msgsend.screen.memberInquiry.button.send": "Enviar",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "Obrigado! Sua mensagem foi enviada com sucesso para o fornecedor.",
                "feedback.msgsend.control.stickLogin.email.must": "Insira o e-mail ou ID de usuário",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Por favor, me recomende outros fornecedores caso este entre em contato comigo através da \"Central de mensagens\" em menos de 24 horas.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Sua mensagem deve ter de 2 a 8.000 caracteres",
                "feedback.msgsend.control.privacy": "Eu concordo em partilhar o meu <span class=\"stress\"> Cartão de Visita</span> com o(s) fornecedor (es).",
                "feedback.msgsend.screen.inquiry.from": "De",
                "feedback.msgsend.screen.inquiry.message": "Mensagem",
                "feedback.msgsend.whatyouneed": "Deixe que fornecedores apropriados verificados te encontrem. \nApenas nos diga o que você precisa!",
                "Aselfintroduction": "- Uma apresentação pessoal",
                "feedback.msgsend.getquatation": "Solicitar Cotações",
                "feedback.msgsend.control.msgQuantity.limit.number": "Por favor, insira um número.",
                "Specialrequestsifany": "- Pedidos especiais (se houver)",
                "feedback.msgsend.control.msgQuantity.quantity": "Quantidade",
                "feedback.msgsend.screen.inquiry.message.info": "Insira os detalhes da sua consulta, como nome do produto, cor, tamanho, quantidade mínima, preço FOB, etc.",
                "feedback.msgsend.control.tipContent.view.sample": "Ver exemplo",
                "Forbetterresponsespleaseinclude": "Para receber melhores respostas, inclua:",
                "feedback.msgsend.control.msgContent.msg.must": "Por favor, insira o conteúdo."
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "ru-ru": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "Кому",
                "feedback.msgsend.screen.memberInquiry.button.send": "Отправить",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "Спасибо! Ваше сообщение уже успешно  отправлено поставщику.",
                "feedback.msgsend.control.stickLogin.email.must": "Введите e-mail.",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Рекомендовать похожих поставщиков, если этот поставщик не ответил в течении 24 ч.\n",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Ваше сообщение должно быть в пределах 20-8000 символов",
                "feedback.msgsend.control.privacy": "Я согласен поделиться своей  <span class=\"stress\">бизнес-карточкой</span> с поставщиком (ми)",
                "feedback.msgsend.screen.inquiry.from": "От",
                "feedback.msgsend.screen.inquiry.message": "Сообщение",
                "feedback.msgsend.whatyouneed": "Позвольте подходящим проверенным поставщикам найти вас.\nПросто скажите нам, что вам нужно！",
                "Aselfintroduction": "- информацию о себе;",
                "feedback.msgsend.getquatation": "Получить расценки",
                "feedback.msgsend.control.msgQuantity.limit.number": "Пожалуйста введите число.",
                "Specialrequestsifany": "- особые запросы, если есть.",
                "feedback.msgsend.control.msgQuantity.quantity": "Количество",
                "feedback.msgsend.screen.inquiry.message.info": "Введите детали вашего запроса, например, название товара, цвет, размер, минимальное количество заказа, цену FOB и т. д.",
                "feedback.msgsend.control.tipContent.view.sample": "Посмотреть образец",
                "Forbetterresponsespleaseinclude": "Для лучших ответов, пожалуйста, укажите:",
                "feedback.msgsend.control.msgContent.msg.must": "Укажите содержимое."
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "th-th": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "ถึง",
                "feedback.msgsend.screen.memberInquiry.button.send": "ส่ง",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "ขอบคุณ! ข้อความของคุณถูกส่งถึงซัพพลายเออร์สำเร็จเรียบร้อยแล้ว",
                "feedback.msgsend.control.stickLogin.email.must": "ใส่อีเมล์หรือเลขสมาชิก",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "กรุณาแนะนำผู้ขายรายอื่นๆ เพิ่มเติมหากผู้ขายรายนี้ไม่ติดต่อฉันผ่าน \"ศูนย์รวมข้อความ\" ภายใน 24 ชั่วโมง",
                "feedback.msgsend.control.msgContent.msg.char.limit": "ข้อความของคุณต้องยาวระหว่าง 20-8000 ตัวอักษร",
                "feedback.msgsend.control.privacy": "ฉันตกลงที่จะแชร์<span class=\"stress\">นามบัตรกั</span>บผู้ขาย",
                "feedback.msgsend.screen.inquiry.from": "จาก",
                "feedback.msgsend.screen.inquiry.message": "ข้อความ",
                "feedback.msgsend.whatyouneed": "ให้ผู้ขายที่ได้รับการยืนยันติดต่อมาหาคุณเอง\nแค่บอกกับเราถึงสิ่งที่คุณต้องการ",
                "Aselfintroduction": "- การแนะนำตัว",
                "feedback.msgsend.getquatation": "ขอใบเสนอราคา",
                "feedback.msgsend.control.msgQuantity.limit.number": "โปรดใส่ตัวเลข",
                "Specialrequestsifany": "- ความต้องการพิเศษ ถ้ามี",
                "feedback.msgsend.control.msgQuantity.quantity": "จำนวน",
                "feedback.msgsend.screen.inquiry.message.info": "ใส่รายละเอียดใบสอบถามราคา เช่น ชื่อสินค้า สี ขนาด MOQ FOB ฯลฯ",
                "feedback.msgsend.control.tipContent.view.sample": "ดูตัวอย่าง",
                "Forbetterresponsespleaseinclude": "เพื่อการตอบรับที่ดีขึ้น กรุณารวม:",
                "feedback.msgsend.control.msgContent.msg.must": "กรุณาใส่เนื้อหา"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "tr-tr": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "Hedef",
                "feedback.msgsend.screen.memberInquiry.button.send": "Gönder",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "Teşekkürler! İletiniz başarıyla tedarikçiye gönderilmiştir.",
                "feedback.msgsend.control.stickLogin.email.must": "Eposta yada Üye Adını girin.",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Bu tedarikçi benimle 'mesaj merkezi' üzerinden 24 saat içinde iletişime geçmezse, lütfen daha fazla seçilmiş tedarikçi önerin.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "İletiniz 20-8000 karakter arasında olmalıdır",
                "feedback.msgsend.control.privacy": "<span class=\"stress\">Kartviziti</span> mi tedarikçi(ler)le paylaşmayı kabul ediyorum.",
                "feedback.msgsend.screen.inquiry.from": "Buradan",
                "feedback.msgsend.screen.inquiry.message": "İleti",
                "feedback.msgsend.whatyouneed": "Eşleşmiş Onaylanmış tedarikçierin seni bulmasına izin ver. Bize sadece neye ihtiyacın olduğunu söyle!",
                "Aselfintroduction": "- Kendinize ait bir tanıtım",
                "feedback.msgsend.getquatation": "Fiyatları Al",
                "feedback.msgsend.control.msgQuantity.limit.number": "Lütfen bir sayı girin.",
                "Specialrequestsifany": "- Varsa özel talepler",
                "feedback.msgsend.control.msgQuantity.quantity": "Miktar",
                "feedback.msgsend.screen.inquiry.message.info": "Ürün adı, renk, boyut, MSM, FOB gibi talep detaylarınızı girin.",
                "feedback.msgsend.control.tipContent.view.sample": "Örneği Görüntüle",
                "Forbetterresponsespleaseinclude": "Daha iyi yanıtlar için, lütfen şunları dâhil edin:",
                "feedback.msgsend.control.msgContent.msg.must": "Lütfen içeriği girin."
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "vi-vi": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "Tới",
                "feedback.msgsend.screen.memberInquiry.button.send": "Gửi",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "Cảm ơn bạn! Tin nhắn của bạn đã được gửi tới nhà cung cấp thành công.",
                "feedback.msgsend.control.stickLogin.email.must": "Nhập thư điện tử hoặc ID Thành viên",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "Vui lòng giới thiệu thêm các nhà cung cấp được lựa chọn nếu nhà cung cấp này không liên hệ với tôi tại 'trung tâm thông báo' trong 24 giờ.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "Tin nhắn của bạn phải có từ 20 đến 8000 ký tự",
                "feedback.msgsend.control.privacy": "Tôi đồng ý chia sẻ <span class=\"stress\">Danh thiếp của</span> tôi với (các) nhà cung cấp.",
                "feedback.msgsend.screen.inquiry.from": "Từ",
                "feedback.msgsend.screen.inquiry.message": "Lời nhắn",
                "feedback.msgsend.whatyouneed": "Hãy để các nhà cung cấp đã được xác minh tìm thấy bạn. Chỉ cần cho chúng tôi biết bạn cần gì!",
                "Aselfintroduction": "- Một bảng tự giới thiệu ",
                "feedback.msgsend.getquatation": "Nhận báo giá ngay!",
                "feedback.msgsend.control.msgQuantity.limit.number": "Vui lòng nhập 1 số.",
                "Specialrequestsifany": "- Yêu cầu đặc biệt, nếu có ",
                "feedback.msgsend.control.msgQuantity.quantity": "Số lượng",
                "feedback.msgsend.screen.inquiry.message.info": "Nhập thông tin yêu cầu của bạn như tên sản phẩm, màu sắc, kích thước, MOQ, FOB, vv.",
                "feedback.msgsend.control.tipContent.view.sample": "Xem mẫu",
                "Forbetterresponsespleaseinclude": "Để trả lời tốt hơn, xin vui lòng đính kèm: ",
                "feedback.msgsend.control.msgContent.msg.must": "Vui lòng nhập nội dung."
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "zh-cn": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "收件人",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "您的消息已经发送成功",
                "feedback.msgsend.screen.memberInquiry.button.send": "发送",
                "feedback.msgsend.control.msgQuantity.limit.number": "请输入数字",
                "feedback.msgsend.control.stickLogin.email.must": "输入email",
                "feedback.msgsend.control.msgContent.msg.char.limit": "您的消息长度必须在20-8000之间",
                "feedback.msgsend.control.privacy": "我同意向收件人分享我的 <span class=\"stress\">商务名片</span>。",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "如果此供应商没有于24小时内在消息中心联系我，我希望阿里巴巴为我推荐其他优选供应商。",
                "Specialrequestsifany": "- 特殊要求",
                "feedback.msgsend.control.msgQuantity.quantity": "数量",
                "feedback.msgsend.screen.inquiry.from": "发送人",
                "feedback.msgsend.screen.inquiry.message": "采购需求",
                "feedback.msgsend.whatyouneed": "让经过验证的供应商找到您。\n只需告诉我们您的需求！",
                "feedback.msgsend.screen.inquiry.message.info": "输入您的询盘信息，例如产品名称、颜色、尺寸、最小起订量、FOB价等",
                "feedback.msgsend.control.tipContent.view.sample": "查看示例",
                "Aselfintroduction": "- 自我简介",
                "feedback.msgsend.getquatation": "采购需求",
                "Specialrequestsifany": "- 采购需求",
                "Forbetterresponsespleaseinclude": "为了得到更好的回应, 最好包含以下信息:",
                "feedback.msgsend.control.msgContent.msg.must": "请填写您的采购需求."
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "zh-tw": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "收件人",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "您的消息已經發送成功",
                "feedback.msgsend.screen.memberInquiry.button.send": "發送",
                "feedback.msgsend.control.msgQuantity.limit.number": "請輸入數字",
                "feedback.msgsend.control.stickLogin.email.must": "請輸入郵箱.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "您的消息長度必須在20-8000之間",
                "feedback.msgsend.control.privacy": "我同意向收件人分享我的 <span class=\"stress\">名片</span>。",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "如果此供應商沒有於24小時內在消息中心聯繫我，我希望阿里巴巴為我推薦其他優選供應商。",
                "Specialrequestsifany": "- 特殊要求，如果有的話",
                "feedback.msgsend.control.msgQuantity.quantity": "數量",
                "feedback.msgsend.screen.inquiry.from": "發送人",
                "feedback.msgsend.screen.inquiry.message": "採購要求",
                "feedback.msgsend.whatyouneed": "讓經過驗證的供應商找到您\n只需告訴我們您的需求！",
                "feedback.msgsend.screen.inquiry.message.info": "輸入詢問板材信息的您，例如產品範圍，顏色，大小，是最小的訂閱數量， FOB價格等等",
                "feedback.msgsend.control.tipContent.view.sample": "查看示例",
                "Aselfintroduction": "- 自我簡介",
                "feedback.msgsend.getquatation": "採購要求",
                "Forbetterresponsespleaseinclude": "為了得到更好的回應, 最好包含以下信息:",
                "feedback.msgsend.control.msgContent.msg.must": "請填寫您的採購要求。"
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })(),
    "hindi": (function() {
        var exports = {},
            module = {
                exports: exports
            };

        module.exports = {
            "app": {
                "feedback.msgsend.screen.memberInquiry.to": "करने के लिए",
                "feedback.msgsend.control.mcSuccess.popupsuc.sendsuc": "धन्यवाद! आपका संदेश आपूर्तिकर्ता को सफलतापूर्वक भेज दिया गया है.",
                "feedback.msgsend.screen.memberInquiry.button.send": "भेजे",
                "feedback.msgsend.control.msgQuantity.limit.number": "एक संख्या दर्ज करें.",
                "feedback.msgsend.control.stickLogin.email.must": "प्रवेश ईमेल या सदस्य id.",
                "feedback.msgsend.control.msgContent.msg.char.limit": "आपके संदेश में 20-8000 अक्षर हो सकते हैं",
                "feedback.msgsend.control.privacy": "मैं साझा करने के लिए सहमत  <span class=\"stress\">मेरा व्यापार कार्ड</span> आपूर्तिकर्ता को है।",
                "feedback.msgsend.control.msgAddTradeAlert.trade.check.newalert": "आकर्षक मिलान आपूर्तिकर्ताओं अगर इस आपूर्तिकर्ता संदेश केंद्र पर 24 घंटे के भीतर मुझसे संपर्क नहीं किया।",
                "Specialrequestsifany": "- विशिष्ट आवेदन, अगर कोई हो तो",
                "feedback.msgsend.control.msgQuantity.quantity": "मात्रा",
                "feedback.msgsend.screen.inquiry.from": "से",
                "feedback.msgsend.screen.inquiry.message": "संदेश",
                "feedback.msgsend.whatyouneed": "सत्यापित आपूर्तिकर्ताओं को आपकी तलाश करने दें. बस हमें बताएँ कि आपको क्या चाहिए!",
                "feedback.msgsend.screen.inquiry.message.info": "आपकी जांच के विवरण प्रवेश करे जैसे की उत्पाद का नाम, रंग, आकार, moq, एफओबी, आदि",
                "feedback.msgsend.control.tipContent.view.sample": "देखें नमूना",
                "Aselfintroduction": "- एक आत्म परिचय",
                "feedback.msgsend.getquatation": "अब उद्धरण प्राप्त करे!",
                "Forbetterresponsespleaseinclude": "बेहतर के लिए कोटेशन, शामिल हैं:",
                "feedback.msgsend.control.msgContent.msg.must": "कृपया सामग्री डालें."
            },
            "appName": "intl-gangesweb",
            "common": {}
        };

        return module.exports;
    })()
};

function _(locale) {
    var r = i18n[map[locale] || 'en-us'];
    r._ = _;
    return r;
}
try {
    var locale = seajs.data.vars.locale;
} catch (e) {
    var locale = 'en-us';
}
module.exports = _(locale);
